var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareerLevel = function SvgCareerLevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_2619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8812 4.49999H14.6812V17.1H3.88125V4.49999H5.68125V3.59999C5.68125 3.1226 5.87089 2.66476 6.20846 2.3272C6.54602 1.98963 7.00386 1.79999 7.48125 1.79999H11.0812C11.5586 1.79999 12.0165 1.98963 12.354 2.3272C12.6916 2.66476 12.8812 3.1226 12.8812 3.59999V4.49999ZM15.5812 4.49999H16.4812C16.9586 4.49999 17.4165 4.68963 17.754 5.0272C18.0916 5.36476 18.2812 5.8226 18.2812 6.29999V15.3C18.2812 15.7774 18.0916 16.2352 17.754 16.5728C17.4165 16.9103 16.9586 17.1 16.4812 17.1H15.5812V4.49999ZM2.98125 4.49999V17.1H2.08125C1.60386 17.1 1.14602 16.9103 0.808458 16.5728C0.470892 16.2352 0.28125 15.7774 0.28125 15.3V6.29999C0.28125 5.30999 1.09125 4.49999 2.08125 4.49999H2.98125ZM7.48125 3.59999V4.49999H11.0812V3.59999H7.48125Z",
    fill: "#18191F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_2619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.28125)"
  })))));
};
export default SvgCareerLevel;